import { render, staticRenderFns } from "./buyerBillList.vue?vue&type=template&id=264c304b&"
import script from "./buyerBillList.vue?vue&type=script&lang=js&"
export * from "./buyerBillList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports